module.exports = __webpack_public_path__ + "img/voucher-empty.656a745e.svg";